/**
 * Maps common Firebase spellings to journey `ecardPreset` slugs used in the app.
 * Returns "" if unknown (caller falls back to URL occasion / egift).
 */

const KNOWN = new Set([
  "egift",
  "anniversary",
  "birthday",
  "invitation",
  "proposal",
  "missing-message",
]);

const ALIASES = {
  invite: "invitation",
  wedding: "invitation",
  "wedding-invitation": "invitation",
  weddinginvitation: "invitation",
  bday: "birthday",
};

export function canonicalEcardPreset(raw) {
  let s = String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");
  if (!s) return "";
  if (ALIASES[s]) s = ALIASES[s];
  if (KNOWN.has(s)) return s;
  return "";
}
